import React, { useState } from 'react';
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  TableRow,
  Tooltip,
  Typography,
  TableHead,
  TableContainer,
  FormControlLabel,
  FormGroup,
  TableBody,
  Table,
  Box,
  Chip,
  Avatar,
  tableCellClasses,
  TablePagination,
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  StyledTableCell,
  StyledTableRow,
  styleimg,
  stylename,
  styleRate,
  styleRating,
} from './CommonTableStyle';
import {
  IOSSwitch,
  StyledCheckbox,
} from 'pages/configuration/addCompliance/AddComplianceStyleTab';
import ProgressBar from 'components/progressBar/ProgressBar';
import { dateFormate, getTimeFormat, truncateComment } from 'utils/utils';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import editmore from 'assets/images/moreEditIcon.svg';
import deleteicon from 'assets/images/delete.svg';
import deactive from 'assets/images/deActivate.svg';
import block from 'assets/images/block.svg';
import starImg from 'assets/images/smStar.svg';
import profile from 'assets/images/profileImg.svg'

export default function CommonTable(props) {
  const { page, rowsPerPage, moreIconData } = props;
  let data = props?.data
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleChangePage = (event, newPage) => {
    props.handleChangePage(event, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    props?.handleChangeRowsPerPage(event);
  };

  const handleMenuOpen = (event, row) => {
    event.preventDefault()
    event.stopPropagation()
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const onClickTableVendor = (val) => {
    if(props?.from){
      props?.onClickId(val, props?.from);
    }else{
      props?.onClickTableVendor(val);
    }
  };

  const getConditionalMenuItems = (status) => {
    if(props?.tabName === 'cabCategory' || props?.tabName === 'feedback'){
      switch (status?.toLowerCase()) {
        case 'active':
          return ['Edit', 'Deactivate'];
        case 'inactive':
          return ['Activate'];
        case 'blocked':
          return ['Unblock'];
        default:
          return ['Edit'];
      }
    }else if(props.tabName ==='vehicle'){
      switch (status?.toLowerCase()) {
        case 'active':
          return [ 'Deactivate'];
        case 'inactive':
          return ['Activate'];
        case 'blocked':
          return ['Unblock'];
        case 'Pending':
            return ['Upload Compliance','Edit'];
        default:
          return ['Upload Compliance'];
      }
    }else if(props?.tabName === "compliance"){
      return ["Edit"]
    }else if (props?.tabName === 'unAssignTab') {
      return ['Reassign', 'Unassign']
    }else{
      switch (status?.toLowerCase()) {
        case 'active':
          if(props?.tabName === 'customer'){
            return ['Block'];
          }else{
            return ['Edit', 'Deactivate', 'Block'];
          }
        case 'inactive':
          return ['Activate', 'Block'];
        case 'blocked':
          return ['Unblock'];
        case 'pending':
          if(props?.tabName === 'customer'){
            return []
          }else{
            return ['Edit'];
          }
        default:
          return [];
      }
    }
  };

  const onClickMoreIcon = (event, data, type) => {
    event.preventDefault()
    event.stopPropagation()
      props?.onClickMoreIcon(data, type);
      handleMenuClose(); 
  };

  const onCheckChange = (e, ele, key, id) => {
    props?.onCheckChange(ele, key, id)
    
  }

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case 'blocked': case 'block': case 'unblock':
        return block;
      case 'edit':
        return editmore;
      case 'deactivate': case 'activate':
        return deactive;
      case 'delete':
        return deleteicon;
      default:
        return;
    }
  };
  const tableHeadKey = (className,key) =>{
   if(className){
    return 'iconColumn';
   }
   else if(key === 'dropping' ||
      key === 'pickup' ||
      key === 'description' ||
      key === 'comment')
      {
        return 'font14'
      }
    else {
      return ''
    }
}
const tableBodyKey = (key) =>{
  if(key === 'comment' || key === 'description' ){
    return 'font14 fontNormal colorGrey'
  }
  else if(key === 'location'){
    return 'fontNormal'
  }
  else if(key === 'dropping' || key === 'pickup'){
    return 'font14 fontNormal'
  }
}

  return (
    <div>
      <TableContainer className="tableMain">
        <Table
          sx={{ [`& .${tableCellClasses.root}`]: { borderBottom: 'none' } }}
          aria-label="customized table"
        >
          <TableHead className="tableborder">
            <TableRow className="commonTableRow">
              {data?.header?.map((ele) => (
                <StyledTableCell
                  key={ele.label}
                  align="left"
                  className={`comColumnWidth font14 fontMedium ${tableHeadKey(ele.className,ele.key)}`}
                >
                  {ele.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="tableBodyStyle">
            {data?.body && data?.body?.length > 0 ? (
              data?.body?.map((ele, id) => (
                <StyledTableRow
                  key={ele.id}
                  onClick={() => props?.
                    isClickable ? 
                    onClickTableVendor(ele)
                   : undefined}
                  disabled={ele.status === 'Blocked'}
                  className={`${props?.isClickable ? 'cursor clickableRow' : 'cursorDefault'} ${ele.gender === "Female" ? 'bgFemale' : ''}`}
                >
                  {data?.header?.map((val, idx) => (
                    <StyledTableCell
                      align="left"
                      key={val.label}
                      disabled={ele.status === 'Blocked'}
                      className={`comRowChildWidth ${tableBodyKey(ele.key)}`}
                    >
                      {val.key === ele['imageflag'] ? (
                        <Box
                          style={styleimg}
                        >
                          {val.key === ele['imageflag'] && (
                            <img
                              style={stylename}
                              className="width33"
                              src={ele?.avtar?.url ? ele?.avtar?.url : profile}
                              alt="vendorimage"
                            />
                          )}
                          <span>
                          <Tooltip title={ele[val.key]} placement="bottom">
                            {truncateComment(ele[val.key], 20)}
                          </Tooltip> <br />
                            {ele?.category && (
                              <span className="font12 fontNormal colorGrey">
                                {ele.category}
                              </span>
                            )}
                          </span>
                        </Box>
                      ) : val.key === 'rating' ? (
                        <Box style={styleimg}>
                            {ele[val.key] && ele[val.key] !== null && <img
                              src={starImg}
                              alt="vendorimage"
                              className="width16"
                              style={stylename}
                            />}
                          <span className="fontWeight400">{ele[val.key]}</span>
                        </Box>
                      ) : val.key === 'documentname' ? (
                        <Box style={styleimg}>
                          {ele.star && (
                            <img
                              src={ele.star}
                              alt="vendorimage"
                              className="feedbackStar"
                            />
                          )}
                          <div style={styleRate}>{ele[val.key]}</div>
                          <div style={styleRating}>{ele.ratingmsg}</div>
                        </Box>
                      ): val.key === 'starValue' ? (
                        <Box style={styleimg}>
                            <img
                              src={starImg}
                              alt="vendorimage"
                              className="width16"
                              style={stylename}
                            />
                          <span className="fw600">{ele[val.key] ? ele[val.key] : 0}</span>
                          <span>&nbsp;Rating</span>
                        </Box>
                      ) : val.key === ele['currencyFlag'] ? (
                        <Box className={ele['currencyFlag'] === 'price' ? "w100" : null}>
                          <span >
                          <Tooltip title={'₹ '+ele[val.key]} placement="bottom">
                            {ele['currencyFlag'] === 'price' ? truncateComment('₹ '+ele[val.key], 8): '₹ '+ele[val.key]}
                          </Tooltip></span>
                        </Box>
                      ): val.key === 'carType' ? (
                        <Box>
                          <div >{ele[val.key]}</div>
                          <div className='font12 colorGrey'>{ele.regNumber}</div>
                        </Box>
                      ): val.key === 'documentStatus' ? (
                        <Box>
                          <div className="progressAlign">
                            <span className="tableProgressBar">
                              <ProgressBar
                                approvedCount={ele?.ApprovedCount}
                                rejectCount={ele?.rejectCount}
                                totalRequired={ele?.totalRequired}
                              />
                            </span>
                            <span className="tableProgressBarText">
                              {ele[val.key]}
                            </span>
                          </div>
                        </Box>
                      ) : val.key === 'comment' ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 20)}
                        </Tooltip>
                      ): val.key === 'email' ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                        </Tooltip>
                      ) :(ele['pickup'] === val.key || val.key === 'sourceAddress')? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                          {/* // TODO: below we dont need to show same time and date */}
                          {/* {ele?.scheduledTime && (
                            <div className="font10 colorGrey">
                              {dateFormate(ele['scheduledTime'], 'DD MMM YYYY, hh:mm a')}
                            </div>
                          )} */}
                        </Tooltip>
                      ) : (ele['drop'] === val.key || val.key === 'destinationAddress') ? (
                        <Tooltip title={ele[val.key]} placement="bottom">
                          {truncateComment(ele[val.key], 25)}
                          {ele?.completedAt && (
                            <div className="font10 colorGrey">
                              {dateFormate(ele['completedAt'], 'DD MMM YYYY, hh:mm a')}
                            </div>
                          )}
                        </Tooltip>
                      ) : val.label === "Rep. Time" ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {getTimeFormat(ele['scheduledTime'])}
                          </Typography>
                        </Box>
                      ): val.key === 'joinDate' ? (
                        dateFormate(ele[val.key], 'DD MMMM YYYY')
                      ) : val.key === 'updatedAt' ? (
                        dateFormate(ele[val.key], 'DD MMMM YYYY')
                      ) : val.key === 'scheduledTime' ? (
                        dateFormate(ele[val.key], 'DD MMMM YYYY')
                      ) : val.key === 'status' ? (
                        <Typography
                          className={`textTransformInherit fontNormal ${
                            ele?.status + 'Btn'
                          }`}
                          variant="contained"
                          disabled={ele.status === 'Blocked'}
                        >
                          {ele[val.key]}
                        </Typography>
                      ) : val.key === 'action' ? (
                        <Button
                          className={`textTransformInherit fontNormal ${
                            ele?.action?.toLowerCase() + 'Btn'
                          }`}
                          variant="contained"
                          onClick={() => {onClickTableVendor(ele)}}
                        >
                          {ele[val.key]}
                        </Button>
                      ) : val.key === 'icon' && props?.tabName !=='rideTrack' ? (
                        <div className='floatRight'>
                          <Button
                            onClick={(event) => handleMenuOpen(event, ele)}
                          >
                            <div className="colorGrey">{<MoreVertIcon />}</div>
                          </Button>
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(
                              anchorEl && selectedRow?.id === ele.id
                            )}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right',
                            }}
                          >
                            {moreIconData && moreIconData.length > 0
                              ? // Render the menu items using moreIconData if it is available
                                moreIconData.map((moreData, idx) => (
                                  <MenuItem
                                    onClick={(e) =>
                                      onClickMoreIcon(e, ele, moreData?.name)
                                    }
                                    selected={selectedItem === moreData?.name}
                                    key={moreData?.id}
                                  >
                                     {moreIconSrc(moreData?.name)?.length > 0 && (
                                    <span className="marginRight10 alignItem">
                                      <img
                                        src={moreIconSrc(moreData?.name)}
                                        alt={moreData?.name}
                                      />
                                    </span>)}
                                    <Typography className="font16 fontSemi">
                                      {moreData?.name}
                                    </Typography>
                                  </MenuItem>
                                ))
                              : // Render the custom menu items if moreIconData is not available
                                getConditionalMenuItems(ele?.status).map(
                                  (moreData, idx) => (
                                    <MenuItem
                                      onClick={(e) =>
                                        onClickMoreIcon(e, ele, moreData)
                                      }
                                      selected={selectedItem === moreData}
                                      key={moreData}
                                    >
                                       {moreIconSrc(moreData)?.length > 0 && (
                                      <span className="marginRight10 alignItem">
                                        <img
                                          src={moreIconSrc(moreData)}
                                          alt={moreData}
                                        />
                                      </span>)}
                                      <Typography className="font16 fontSemi">
                                        {moreData}
                                      </Typography>
                                    </MenuItem>
                                  )
                                )}
                          </Menu>
                        </div>
                      ) : val.key === 'amount' &&
                        props.from === 'dashboardRide' ? (
                        <Grid>
                          <div>{ele[val.key]}</div>
                          {ele?.status && (
                            <div className={`font12 ${ele.status + 'Btn'}`}>
                              {ele['status']}
                            </div>
                          )}
                        </Grid>
                      ) : val.key === 'pickup' && props.from === 'rideTrack' ? (
                        <Grid>
                          <div>{ele[val.key]}</div>
                          {ele?.pickupDate && (
                            <div className="font10 colorGrey">
                              {ele['pickupDate']}
                            </div>
                          )}
                        </Grid>
                      ) : val.key === 'car' && props.from === 'rideTrack' ? (
                        <Grid>
                          <div>{ele[val.key]}</div>
                          {ele?.pickupDate && (
                            <div className="font10 colorGrey">
                              {ele['carNumber']}
                            </div>
                          )}
                        </Grid>
                      ) : val.key === 'isActive' ? (
                        <FormGroup className="switchButton">
                          <FormControlLabel
                            control={<IOSSwitch checked={ele[val.key]} onChange={(e) => {onCheckChange(e, ele, val.key, id)}} />}
                          />
                        </FormGroup>
                      ) : (val.key === 'isMandatory') ? (
                        <StyledCheckbox checked={ele[val.key]} onChange={(e) => {onCheckChange(e, ele, val.key, id)}}/>
                      ): (val.key === 'isExpiring') ? (
                        <StyledCheckbox checked={ele[val.key]} onChange={(e) => {onCheckChange(e, ele, val.key, id)}}/>
                      ): (val.key === 'tags') ? (
                        ele[val.key]?.toString()?.split(',')?.join(', ')
                      ): (val.key === 'Facilities') ? (
                        (ele?.Facilities?.map((data) => (<Chip className='chipSizeStyle'
                          avatar={<Avatar alt="Natacha" src={data?.img?.url} />}
                          label={data?.name}
                          variant="outlined"
                        />)))
                      ) : (val.key === ele['isDateFormat']) ? (
                        dateFormate(ele[val.key], 'DD MMMM YYYY')
                      ) : (
                        ele[val.key]
                      )}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={data?.header?.length} align="center">
                  <CommonNoDataFound/>
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.body &&
        data?.body?.length > 0 &&
        data?.totalCount > 10 && (
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={data?.totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
    </div>
  );
}
